import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import SidebarLayout, { MenuGroup } from "./SidebarLayout";

// Section "Navette de paie" — complètement séparée de Chiffrage Projets et de Matrice Régie.
const menuData: MenuGroup[] = [
    {
        groupName: "Paie",
        items: [
            { icon: <ReceiptLongIcon />, text: "Navette de paie", page: "/navette-paie" },
        ],
        // TODO: remettre requiredRole: "directions" une fois la fonctionnalité validée
    },
];

export default function LayoutPayroll() {
    return <SidebarLayout menuData={menuData} />;
}
